module.exports = __webpack_public_path__ + "img/cross.9818101b.svg";